import { EnumBuilder, type ZodInfer } from '@mntn-dev/utility-types'

import { ChargeStates } from '../billing/charge-status.ts'

export const [PaymentStates, PaymentStatusSchema] = EnumBuilder(
  ...ChargeStates,
  'requested',
  'under_review',
  'scheduled',
  'rejected',
  'canceled'
)

export type PaymentStatus = ZodInfer<typeof PaymentStatusSchema>
